const BUFOS = [
  "/bufo/bufo-adidas.png",
  "/bufo/bufo-arrrrrrrrrrrrrrr.png",
  "/bufo/bufo-australian.png",
  "/bufo/bufo-authority.png",
  "/bufo/bufo-aviation.png",
  "/bufo/bufo-baker.png",
  "/bufo/bufo-book.png",
  "/bufo/bufo-burrito.png",
  "/bufo/bufo-hotdog.png",
  "/bufo/bufo-oblivious.png",
];

const BUFO_CAPTIONS = [
  "Legend has it, if you stumble upon the Magic Bufo, your luck instantly levels up – like finding a $20 bill in your old jeans. This mystical creature is said to grant good fortune to those who admire its froggy charm (or at least a really good mood). Just don’t ask it for stock tips... Bufo only deals in vibes.",
  "Behold, the Rare Bufo of Fortune – gaze upon it, and you’ll start finding good parking spots and perfectly ripe avocados. It’s not magic, it’s just… well, actually, it’s probably magic. Don’t question the Bufo; just let the good luck roll in.",
  "Rumor has it that if you whisper your wish to the Magic Bufo, it will nod wisely and proceed to ignore you completely. But hey, your luck might still improve – it’s all about the vibes. Frogs know things we don’t.",
  "This majestic Bufo appeared at the exact moment you needed a little luck. Coins in couch cushions? Coming your way. Hot coffee on a cold morning? Already brewing. Bufo’s got you covered.",
  "The Great Bufo of Benevolence has chosen you. Your socks will never go missing again, and your phone battery will always hit 1% at just the right time. Small miracles, Bufo-style.",
  "Finding this Bufo is like rolling a natural 20 on the dice of life. You’ve entered the land of good vibes, mild fortune, and surprisingly happy coincidences. All hail the Bufo!",
];

export const getRandomBufo = () => getRandom(BUFOS);

export const getRandomBufoCaption = () => getRandom(BUFO_CAPTIONS);

const getRandom = (items: any[]) => items[Math.floor(Math.random() * items.length)];

/**
 * Regex to match a UUID where one of the sets of 4 characters is "bufo".
 * e.g.: 123e4567-e89b-a456-bufo-426614174000
 */
const BUFO_UUID_REGEX =
  /^[0-9a-fA-F]{8}-([0-9a-fA-F]{4}|bufo)-([0-9a-fA-F]{4}|bufo)-([0-9a-fA-F]{4}|bufo)-[0-9a-fA-F]{12}$/;

export const isBufoUUID: (i: string | undefined) => boolean = (input) => {
  if (!input || !BUFO_UUID_REGEX.test(input)) {
    return false;
  }

  // Split into parts and check for "bufo" in valid spots
  const parts = input.split("-");
  const bufos = parts.filter((p) => p === "bufo");
  return bufos.length == 1;
};
